import { tsValidate, tsValidateMustExist, tsValidateNumber, tsValidateRange, tsValidateValue } from '@nu-art/ts-common';
import { PrognosisRateType_Mortality, PrognosisRateType_Qualitative, PrognosisRateType_Survival, PrognosisValues } from './types.js';
import { TimespansType } from '@app/hcs-shared';
import { Validator_Population } from '../population/index.js';
// ########################### Prognosis Rate Validation ###########################
const Validator_PrognosisValue = tsValidateValue([...PrognosisValues]);
const Validator_PrognosisRate_Qualitative = {
    type: tsValidateValue([PrognosisRateType_Qualitative]),
    value: Validator_PrognosisValue,
};
const Validator_PrognosisRate_Survival = {
    type: tsValidateValue([PrognosisRateType_Survival]),
    value: tsValidateRange(),
};
const Validator_PrognosisRate_Mortality = {
    type: tsValidateValue([PrognosisRateType_Mortality]),
    value: tsValidateRange(),
};
const Validator_PrognosisRate = (rate) => {
    if (!rate)
        return tsValidate(rate, tsValidateMustExist);
    switch (rate.type) {
        case PrognosisRateType_Qualitative:
            return tsValidate(rate, Validator_PrognosisRate_Qualitative);
        case PrognosisRateType_Survival:
            return tsValidate(rate, Validator_PrognosisRate_Survival);
        case PrognosisRateType_Mortality:
            return tsValidate(rate, Validator_PrognosisRate_Mortality);
        default:
            // @ts-ignore
            return `Missing implementation for rate of type ${rate.type}`;
    }
};
// ########################### Time Period Validation ###########################
const Validator_TimePeriodType = tsValidateValue(TimespansType);
const Validator_TimePeriod = {
    type: Validator_TimePeriodType,
    value: tsValidateNumber(),
};
// ########################### Prognosis Validation ###########################
export const Validator_Prognosis = {
    rate: Validator_PrognosisRate,
    timePeriod: Validator_TimePeriod,
    population: Validator_Population,
};
//# sourceMappingURL=validator.js.map